module.exports = __webpack_public_path__ + "static/project-15b-0b7a37a25e3ff572e351ee834a9d5a74.png";